import type { ComponentProps } from 'react';

const PromptStar = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="currentColor"
      {...props}
    >
      <path
        d="M9.45508 2.32969C9.33203 2.37617 9.25 2.49375 9.25 2.625C9.25 2.75625 9.33203 2.87383 9.45508 2.92031L11 3.5L11.5797 5.04492C11.6262 5.16797 11.7437 5.25 11.875 5.25C12.0063 5.25 12.1238 5.16797 12.1703 5.04492L12.75 3.5L14.2949 2.92031C14.418 2.87383 14.5 2.75625 14.5 2.625C14.5 2.49375 14.418 2.37617 14.2949 2.32969L12.75 1.75L12.1703 0.205078C12.1238 0.0820312 12.0063 0 11.875 0C11.7437 0 11.6262 0.0820312 11.5797 0.205078L11 1.75L9.45508 2.32969ZM6.1082 2.0043C6.03711 1.84844 5.88125 1.75 5.71172 1.75C5.54219 1.75 5.38633 1.84844 5.31523 2.0043L3.87148 5.12148L0.754297 6.5625C0.598438 6.63359 0.5 6.78945 0.5 6.96172C0.5 7.13398 0.598438 7.28711 0.754297 7.3582L3.87422 8.79922L5.3125 11.9164C5.38359 12.0723 5.53945 12.1707 5.70898 12.1707C5.87852 12.1707 6.03438 12.0723 6.10547 11.9164L7.54648 8.79648L10.6664 7.35547C10.8223 7.28438 10.9207 7.12852 10.9207 6.95898C10.9207 6.78945 10.8223 6.63359 10.6664 6.5625L7.54922 5.12422L6.1082 2.0043ZM11 10.5L9.45508 11.0797C9.33203 11.1262 9.25 11.2437 9.25 11.375C9.25 11.5063 9.33203 11.6238 9.45508 11.6703L11 12.25L11.5797 13.7949C11.6262 13.918 11.7437 14 11.875 14C12.0063 14 12.1238 13.918 12.1703 13.7949L12.75 12.25L14.2949 11.6703C14.418 11.6238 14.5 11.5063 14.5 11.375C14.5 11.2437 14.418 11.1262 14.2949 11.0797L12.75 10.5L12.1703 8.95508C12.1238 8.83203 12.0063 8.75 11.875 8.75C11.7437 8.75 11.6262 8.83203 11.5797 8.95508L11 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PromptStar;
